export default [
    {
      title: 'menu.AdminPanel',
      icon: 'SettingsIcon',
      tagVariant: 'light-danger',
      route:'adminpanel'
    },
  ]
  